<template>
  <f7-app :params="f7params">
    <!-- Left panel with cover effect-->
    <f7-panel left cover theme-dark>
      <f7-view>
        <f7-page>
          <f7-block-title medium>{{ $root.user.name }}</f7-block-title>
          <f7-block>{{ $root.phoneFormat($root.user.phone) }}</f7-block>
          <f7-list>
            <f7-list-item
              title="Профиль"
              @click="$f7.views.main.router.navigate('/profile/')"
              link="#"
              panel-close
            ></f7-list-item>
            <f7-list-item
              title="История"
              @click="$f7.views.main.router.navigate('/history/')"
              link="#"
              panel-close
            ></f7-list-item>
            <!--f7-list-item
              title="Уведомления"
              @click="$f7.views.main.router.navigate('/notification/')"
              link="#"
              panel-close
            ></f7-list-item-->
          </f7-list>
          <f7-list>
            <f7-list-item
              @click="logout()"
              title="Выход"
              link="#"
            ></f7-list-item>
          </f7-list>
        </f7-page>
      </f7-view>
    </f7-panel>

    <!-- Your main view, should have "view-main" class -->
    <f7-view main class="safe-areas" url="/"></f7-view>

    <!-- Popup -->
    <f7-popup id="my-popup">
      <f7-view>
        <f7-page>
          <f7-navbar title="Popup">
            <f7-nav-right>
              <f7-link popup-close>Close</f7-link>
            </f7-nav-right>
          </f7-navbar>
          <f7-block>
            <p>Popup content goes here.</p>
          </f7-block>
        </f7-page>
      </f7-view>
    </f7-popup>
  </f7-app>
</template>

<script>
import routes from "../js/routes.js";

export default {
  data() {
    return {
      // Framework7 Parameters
      f7params: {
        name: "tipomoika.ru", // App name
        theme: "auto", // Automatic theme detection

        // App routes
        routes: routes,
        // Register service worker
        serviceWorker: {
          path: "/service-worker.js",
        },
        dialog: {
          title: "tipomoika.ru",
          buttonCancel: "Отмена",
        },
        view: {
          pushState: true,
          pushStateSeparator: "#",
          pushStateOnLoad: true,
        },
      },
    };
  },
  methods: {
    logout() {
      this.$f7ready((f7) => {
        // Call F7 APIs here
        f7.dialog.confirm(
          `Вы действительно хотите выйти из приложения?`,
          "Вопрос",
          function () {
            localStorage.clear();
            window.location.reload(false);
          }
        );
      });
    },
  },
  mounted() {
    this.$f7ready((f7) => {
      // Call F7 APIs here
    });
  },
};
</script>